module.exports = {
  nav: {
    home: 'Home',
    about: 'About CBEI',
    ecology: 'GBEI Ecology',
    team: 'Talent power',
    ahead: 'Outlook GBEI',
    contact: 'Contact GBEI',
    gtb: 'GTB'
  },
  foot: {
    tel: 'Tel',
    email: 'Email',
    address: 'Address',
    addressval: 'Yaner Dao Road, Shinan District, Qingdao City, Shandong Province, China6 / F, Hyatt Center Office Building, No.10',
    qr1: 'Subscription number',
    qr2: 'Service number',
  },
  home: {
    img1: '/images/home/en11.jpg',
    img2: '/images/home/en21.jpg',
    cards1: [{
        id: 1,
        img: '/images/home/12.jpg'
      },
      {
        id: 2,
        img: '/images/home/en12.png'
      },
      {
        id: 3,
        img: '/images/home/en13.png'
      },
      {
        id: 4,
        img: '/images/home/15.jpg'
      },
    ],
    cards2: [{
        id: 1,
        icon: '/images/home/21.png',
        title: 'Brand service provider',
        ct: 'GBEI does not make a brand GBEI Achieves Brand GBEI boosts online'
      },
      {
        id: 2,
        icon: '/images/home/22.png',
        title: 'Recycling service provider',
        ct: 'GBEI advocates circular service and is committed to serving 7.5 billion global citizens around the worldEstablished with the logic of the "General Agreement on Tariffs and Trade" (GATT),More consumers will use the GBEI self-organized order-winning system,Spontaneously or consciously pa -rticipate in the GBEI smart contract mechanism'
      }
    ],
    cards3: [{
        id: 1,
        title: "Joint management business",
        bg: '/images/home/01.jpg',
        ct: '/images/home/en01.png',
      },
      {
        id: 2,
        title: "Net immigration",
        bg: '/images/home/02.jpg',
        ct: '/images/home/en02.png',
      },
      {
        id: 3,
        title: "Three innovation collaboration, six network interaction",
        bg: '/images/home/03.jpg',
        ct: '/images/home/en03.png',
      },
      {
        id: 4,
        title: "One net, one shop",
        bg: '/images/home/04.jpg',
        ct: '/images/home/en04.png',
      },
      {
        id: 5,
        title: "Three universal",
        bg: '/images/home/05.jpg',
        ct: '/images/home/en05.png',
      },
      {
        id: 6,
        title: "Five all",
        bg: '/images/home/06.jpg',
        ct: '/images/home/en06.png',
      },
    ],
  },
  ec: {
    img1: '/images/ecology/en01.jpg',
    img2: '/images/ecology/en31.jpg',
    img3: '/images/ecology/en32.jpg',
    img4: '/images/ecology/en33.jpg',
    p1: 'Under the general situation of digital economy, the token economy is surging. Universal channels, universal profits, and universal points are a big change in trade circulation! The interoperability of resources and the linkage of all things are the future value trend.',
    tt11: 'GBEI Token Business',
    ct11: 'Pass E-commerce is an effective integration of Internet commerce and blockchain technology. Internet commerce itself has the characteristics of universality, convenience, and coordination, and blockchain technology has the advantages of fairness, solving trust problems, and non-tamperable modification. The emergence of blockchain will revolutionize the business model of the Internet era. The emergence of this technology can perfectly compensate for the lack of Internet commercial transmission efficiency and deepen the market',
    tt12: 'What is the difference between pass business and internet business and new retail',
    ct12: 'Internet business: indirect business transactions between individuals and enterprises and sales based on the Internet New retail: Driven by information technology, with consumer experience as the core, reconstruct the three elements of offline and online people, goods, and markets to form a new business form Pass Commerce: Pass Commerce realizes the equality of large and small enterprises on the basis of new retail, truly realizes the equality of large and small enterprises, and truly realizes the return of the value of data to users. It will bring us a new world of information technology + freedom and fairness + new business rules + legal norms.',
    timeline: [{
        id: 1,
        date: "Year 1999",
        title: "The first year of Chinese e-commerce",
        text: "China's e-commerce has truly entered the stage of substantial business this year. 8848.com was established in May, eBay was established in August, Alibaba was established in September, Dangdang.com was established in November, and China International E-commerce Application Expo was established on September 6. In addition, Ctrip and Shanda were all established this year",
      },
      {
        id: 2,
        date: "Year 2011",
        title: "Capital competes in the e-commerce industry",
        text: `In the past ten years, more and more venture capital has turned to e-commerce, which has accelerated the listing of e-commerce companies. The establishment of Taobao and Alipay has laid the foundation for Alibaba's huge empire. Jack Ma first proposed the concept of "online business" in 2004. , Then more and more Internet business companies such as JD.com, Meituan, Didi, etc. were born, accelerating the development of the entire Internet business`,
      },
      {
        id: 3,
        date: "Year 2016",
        title: "New retail concepts are popular all over the world",
        text: "In 2016, Jack Ma proposed the concept of “new retail”. Currently, new retail business models of various forms have been formed in the domestic and international markets. Up to now, the profit model is still unstable, which requires a more stable mechanism to promote the upgrade of the new retail model",
      },
      {
        id: 4,
        date: "Year 2019",
        title: "The GBEI pass industry came into being",
        text: "After three years of technology research and development, GBEI has integrated blockchain technology on the basis of new retail to realize the whole chain cycle ecology of Passport City, Cloud Store, Data Dock, and Social APP",
      },
    ],
    tt21: 'Market demand',
    ct21: 'Commodity circulation consumption is the prerequisite for economic development and the foundation of all finance. Cultivate a batch of 100 billion-level commodity markets with good economic performance on the development platform.Commodity circulation system req -uiredby modern economy',
    tt22: 'Guiding Opinions of the Ministry of Commerce',
    ct22: 'Responding to the guidance of the Ministry of Commerce and other 12 departments on the promotion of commodity trading market developm -ent platform economy',
    tt23: 'Development trend',
    ct23: 'Boosting the listing of 300 production-oriented companies, realizing the effective exchange of the identities of consumers, distributors, and manufacturers, making Jingbel associates, and allowing global customers to voluntarily participate in the Jingbel smart contract.',
    tt24: 'Interpretation of the two sessions',
    ct24: 'In 2019, the two sessions proposed that finance should serve the real economy and meet the needs of economic development and the people.',
    tt31: 'GBEI Introduction',
    ct31: 'GBEI (GBEI (Guangzhou) Technology Co., Ltd.), established in December 2017, is headquartered in Guangzhou Nansha Free Trade Zone. Jingbeier mainly consists of four major sectors: Jingbeier Pass Pass Mall, Jingbeier Steel (GB) Cloud Store, Jingbeier Resonance (GM) Community, Jingbeier Meiwei Data Dock, and the four major sectors have been launched one after another. GBEI has created a platform-based joint venture model that participates in market crowdsourcing-the GMB model, which provides a virtuous circle and a future economic model-"order-based consumption, customized production". Jingbeier upholds the business philosophy of "Achievement in Sharing" and grows together with all partners. Create fair trade, promote social integrity, assert consumer sovereignty, and enhance consumer value. Provide all joint entrepreneurs with a joint wealth creation platform of “sharing, win-win, common prosperity, common prosperity, and common”. Taking the in-depth interaction of resources as the cause and the in-depth interaction of interests as the result, using the principles of fan economics and market multiplication, through the value integration of the wealth chain and the integrity chain, the Internet, blockchain, Internet of Things, big data and other technologies are developed into Digital marketing tools serve the public, including functions such as universal points, super aggregate payment, data management, etc.; the perfect integration of online and offline, fully automatic and non-sense marketing, empowers new retail for merchants, recycles services, and promotes consumption. GBEI has applied for a number of software copyrights, patents and trademarks, with complete qualifications and safety. The GMB joint credit plan and the VB calculus plan developed by GBEI complement each other and are dynamically supported. Between different products, between people, between now and in the future, the mutual conversion of credit value and VB profit is mutually confirmed.',
    tt32: 'Company qualification',
    ct32: 'The company has carried out a national distributed pilot in 2018-2019. In 2020, Qingdao will be selected as the national market operation headquarters, and enterprises and individuals interested in the transformation of the real economy will carry out a strategic layout in nearly 100 cities across the country, and build the GBEI Cloud Store Service outlets actively promote the transformation and upgrading of the Internet+ in the real economy. GBEI will establish and improve market service functions, make good use of the third-party platform to hold credibility, horizontally gather resources from associates, and promote global economic development. The GTB model is an inevitable result of the interactive promotion of trade globalization, trade liberalization and general-mobile-business (General-Mobile-Business). .',
    tt41: 'Team leaders',
    img21: '/images/ecology/en21.jpg',
    leader: [{
        id: 1,
        img: '/images/ecology/l1.jpg',
        name: "James Bo",
        job: "Co-founder CSO",
        intro: "President of Huasheng Financial Technology, United States Tsinghua University and University of Cincinnati, United States Dual Master's",
      },
      {
        id: 2,
        img: '/images/ecology/l2.jpg',
        name: "Luo Hongtang",
        job: "President CEO",
        intro: "Presidents of well-known listed companies Honorary consultants of many well-known companies National lecturers International marketing trainers",
      },
      {
        id: 3,
        img: '/images/ecology/l3.jpg',
        name: "Wang Yueheng",
        job: "Ecological Operation Officer",
        intro: "Famous Investor, Corporate Listing Instructor, Special Capital Instructor, School of Government Management, Peking University, Global Youth Entrepreneurship Alliance, China, Former Producer, People's Daily Fortune Magazine",
      },
      {
        id: 4,
        img: '/images/ecology/l4.jpg',
        name: "Jin Kecheng",
        job: "Marketing director",
        intro: "China's top ten famous trainers, cutting-edge lectures, guest speakers, Shenzhen TV Maker Fengyunhui Maker tutor, the first person to make a live speech in China, the first person to make a guest in China, the founder of China's wisdom series",
      },
      // {
      //   id: 5,
      //   img: '/images/ecology/l5.jpg',
      //   name: "来庆友",
      //   job: "技术总监",
      //   intro: "Senior software engineer is certified as PMP project manager in the United States (5A) Six Sigma management black belt proficient in ",
      // },
    ],
    tt51: 'Main business',
    items5: [{
        id: 1,
        img: '/images/ecology/en51.jpg',
        title: "GBEI Pass Mall",
        text: "Mainly aimed at: local products, time-honored brands, new and exotic products, big health, GB special supply and other products for fixed-point customized marketing",
      },
      {
        id: 2,
        img: '/images/ecology/en52.jpg',
        title: "GBEI Cloud Store",
        text: "Offline thousands of cities and tens of thousands of stores plan, aggregate payment, one code connects the world",
      },
      {
        id: 3,
        img: '/images/ecology/en53.jpg',
        title: "Blockchain technology devel -opment and application (da -ta dock)",
        text: "The data dock provides customers with functions such as digital asset storage, interaction, and credit, and performs chain reform, product traceability, and blockchain technology applications for related companies.",
      },
      {
        id: 4,
        img: '/images/ecology/en54.jpg',
        title: "GOME community",
        text: "Software development, social networking, video, live broadcast, games and other in-depth cultural and entertainment interactions are mainly aimed at: local products, time-honored brands, novelties, big health, GB specials and other products for fixed-point customized marketing offline thousands of cities and thousands of stores plan, aggregate payment, One yard connects the world",
      },
    ],
    tt61: 'Patent certificate',
    tt71: 'Times bonus',
    times7: [{
        id: 1,
        date: "Before 2011",
        text: "Physical industry丨factories, supermarkets, department stores",
      },
      {
        id: 2,
        date: "Year 2011",
        text: "The first generation of e-commerce丨Alibaba, Taobao, Jingdong Mall",
      },
      {
        id: 3,
        date: "Year 2014",
        text: "The second generation of e-commerce丨Dianping, Meituan, Pinduoduo, Internet social",
      },
      {
        id: 4,
        date: "Year 2019",
        text: "The third generation of e-commerce丨Internet + finance + blockchain technology, deep integration",
      },
    ],
    tt72: 'Project Benefits',
    cards7: [{
        id: 1,
        img: "/images/ecology/30.jpg",
        title: "Big trend",
        content: "National policy support, ten famous groups joint effort",
      },
      {
        id: 2,
        img: "/images/ecology/31.jpg",
        title: "Low threshold",
        content: "Everyone may participate and everyone may share in the profits",
      },
      {
        id: 3,
        img: "/images/ecology/32.jpg",
        title: "Decentralized",
        content: "Open and transparent data, intelligent contract to ensure fair trading",
      },
      {
        id: 4,
        img: "/images/ecology/33.jpg",
        title: "Tamper Proof",
        content: "Distributed database ledger technology and hash encryption function, to provide a higher level of security",
      },
      {
        id: 5,
        img: "/images/ecology/34.jpg",
        title: "Free circulation",
        content: "Free circulation and exchange in different ecological fields will break the traditional points gap",
      },
      {
        id: 6,
        img: "/images/ecology/35.jpg",
        title: "Super aggregate payment",
        content: "Complete automatic non-senseful marketing of multiple services such as payment collection, powder lock, commission settlement and coupon distribution by scanning the code once",
      },
    ],
    tt81: 'Partners',
    tt82: 'Strategic objectives',
    ct82: [{
        id: 1,
        title: "New trend",
        text: "Has strong vitality and broad market prospects,Represents the trend of future development",
      },
      {
        id: 2,
        title: "New value",
        text: "Features of high return and high growth",
      },
      {
        id: 3,
        title: "New beginning",
        text: "The beginning of a historic turning point",
      },
    ],
    pt: [
      'Many well-known groups across the country and GBEI to build a benchmark for the commercial industry',
      'Crystal Leaf (Qingdao) Biological Technology Co., Ltd.',
      'Hainan Lumin Pharmaceutical Technology Co., Ltd.',
      'Wonder Technology Co , Ltd .',
      'Hainan Sanfengyou Pharmaceutical Co., Ltd.',
      'Shaanxi Handaochang Fu Tea Co., Ltd.',
      'Taian Hesheng Century Biotechnology Co., Ltd.',
      'Beijing Taiai Peptide Bioengineering Technology Co., Ltd.',
      'Zunyi Lusheng Kangyuan Technology Development Co., Ltd.',
      'Qingdao Jingmei Biological Technology Co., Ltd.',
      'Dalian Jintian Special Grain Co., Ltd.',
      'Shandong Miaoyue Biotechnology Co., Ltd.',
      'Guangxi Life Bacteria Biotechnology Co., Ltd.'
    ]
  },
  ou: {
    img1: '/images/ahead/en01.jpg',
    tt1: 'Outlook GBEI',
    times: [{
        id: 1,
        date: "2020.10",
        text: "Launched a 45-day strong fan attraction program, gathering 5,000 GTB loyal fans",
      },
      {
        id: 2,
        date: "2020.12",
        text: "Establish a core marketing structure and complete the layout of the provincial and municipal agency nodes",
      },
      {
        id: 3,
        date: "2021.02",
        text: "Full implementation of landing applications, serving tens of millions of entities, creating a large cluster industry ecological platform, and integrating industry and finance",
      },
      {
        id: 4,
        date: "2021.05",
        text: "Reached strategic cooperation with a number of investment institutions and central enterprises to introduce continuous vitality to the development of the platform",
      },
      {
        id: 5,
        date: "2021.09",
        text: "Improve and update the technical mechanism to provide the platform with lasting and stable technical guarantee",
      },
      {
        id: 6,
        date: "2021.12",
        text: "Select and gather high-quality stores and promote 5,000 physical stores to join the GBEI Cloud Store",
      },
      {
        id: 7,
        date: "2022",
        text: "Introduce domestic and international high-quality capital to build a GTB public chain, so that every company can realize brand value and economic value, share platform resources, and benefit everyone",
      },
      {
        id: 8,
        date: "2023",
        text: "Build your own chain reform exchange, as a guarantee for believers who hold GTB for a long time, and become the world's most trusted chain reform service public chain",
      },
      {
        id: 9,
        date: "2024",
        text: "Officially launched the listing process, becoming the most trusted international platform in the world",
      },
    ],
  },
  gtb: {
    img1: '/images/gtb/en01.jpg',
    cd1: 'GTB "Global Tongbao" general point chain, abbreviated as "GTB Tongbao Chain", it is an open and closed-loop channel for all kinds of commercial consumption points to be capitalized.',
    cd2: 'GTB designed the underlying protocol and basic framework of the integral channel, and realized the communication protocol of multi-party integral value exchange. The integration of point token assets and aggregated commerce can facilitate the confirmation, exchange, transfer and transaction of circulation value through the blockchain.',
    cd3: 'GTB executes built-in smart contracts in investment and consumption channels to realize omni-channel business aggregation in a multidimensional business world.',
    cd4: 'GTB chain adopts a multi-dimensional component architecture, including: data components, network components, consensus components, contract components, application components, etc.',
    cd5: 'GTB Company is committed to building global cooperative merchant points block, realizing the digital asset chain that maximizes the exchange value of merchants, consumers and investors. In the concept of digital assets, points are usually called "Tokens", and the point chain is more embodied in a value system of the blockchain to build a complete closed-loop ecosystem, from users, to applications, to the network , To commercial value, and finally return to users, this will become a complete closed-loop ecosystem.',
    tt1: 'Questions about GTB',
    q1: 'Q: What is the blockchain point ecology?',
    a1: 'Answer: Based on the point (digital asset) issuance, management and circulation network of blockchain technology, any company or individual can easily join and become an asset party and channel party, and cooperate with internal and external enterprises, merchants, channels, issuers, etc. The issuance, exchange and management of points (digital assets) realize the interchange and exchange of different digital assets and the circulation of assets.',
    q2: 'Q: What are the pain points of the traditional integration model?',
    a2: 'Answer: There are many restrictions on point redemption, and the threshold is high; points are too scattered to be shared and accumulated; point issuance is opaque and naturally lacks credibility; under a centralized architecture, the operating platform is extremely complicated; point data is easy to be hacked and has low security;',
    q3: 'Q: What are the advantages of blockchain integration?',
    a3: `Answer: Decentralization: to ensure the openness and transparency of data, and to automatically implement transaction logic through smart contracts with code to ensure the fairness of transactions and make decentralized organization operations possible. Non-tampering: The blockchain distributed database ledger technology and the anti-tampering function of hash encryption provide a higher level of protection for the security of points information and user information. Strong anti-attack: The database is highly stable, and the blockchain ensures the security of users' digital assets by sharing the ledger structure, and avoids the risk of hacking the points data. Even if some nodes are attacked, the integrity of the database will not be affected. Private key is more secure: use private key to sign transactions and consensus algorithms to build a strong security underlying system; each user on the blockchain will have his own private key, and every transaction is signed by the private key, guaranteeing Security in the circulation of points.`
  },
}